import { store } from "../app/store.js";
import {getConfig} from "../app/config.js";

export default {
    template: `
        <div id="ketv-video" class="video-layout hidden">
            <div class="video-wrapper">
                <div id="video-slot" class="video-container hidden">
                    <p class="loading-placeholder">Loading video stream...</p>
                </div>
                <div id="ketv-video-starter" class="video-container hidden" style="cursor: pointer;">
                    <img src="/public/assets/logos/logo.png" alt="King Earthquake Logo" class="logo" />
                    <p class="center">Click to watch</p>
                </div>
                <div id="ketv-stream-ended" class="video-container hidden">
                    <img src="/public/assets/logos/logo.png" alt="King Earthquake Logo" class="logo" />
                    <p class="center">Thanks for tuning in<br/>See you next time</p>
                </div>
<!--                <div class="video-controls">-->
<!--                    <button id="v-play-pause"><i class="fas fa-play"></i> Play</button>-->
<!--                    <button id="v-fullscreen"><i class="fas fa-expand"></i> Fullscreen</button>-->
<!--                </div>-->
            </div>
            
            <div id="chatbox-wrapper" class="side-content">
                <div id="chatbox-placeholder">
                    <p>
                        Our chatbox is hosted by <b>Cbox</b>.<br/><br/>
                        For your privacy, you need to enable the chatbox to confirm you are happy to connect to their service.<br/>
                        <br>
                        For more information, please see our <a href="/privacy">privacy policy</a>.
                    </p>
                    <button id="chatbox-enable">Enable Chatbox</button>
                    <p><a id="chatbox-dismiss">Dismiss</a></p>
                </div>
                <iframe id="chatbox-iframe" class="hidden" allowtransparency="yes" allow="autoplay"></iframe>
            </div>
        </div>
            
        <div id="ketv-timetable" class="section">
            <h1>KETV Radio</h1>
            <p class="center">Errol hosts his own radio shows multiple times a week. Tune in at home or on the go.</p>
            
            <div class="schedule">
                <div class="schedule-column">
                    <h3>Legendary SoundChat</h3>
                    <p class="time">SUNDAYS 6pm - 9pm</p>
                    <p>
                        Legendary Soundchat brings together Errol Arawak and Quaker City in conversation with Veteran Soundmen.
                        Each session shares real journeys from foundation to present day. Covering sound
                        building, music and deeper reasoning behind the culture. A space rooted in history, knowledge and memories. 
                    </p>
                </div>
                <div class="schedule-column">
                    <h3>Strictly Old Skool Roots &amp; Culture Vinyl Night</h3>
                    <p class="time">MONDAYS 8pm - 10pm</p>
                    <p>
                        Start your week with vintage Roots & Culture. Foundation tunes that will uplift your mind and
                        spirit that will take you on a positive journey to see you through the week. Come and enjoy the
                        friendly atmosphere with like-minded people.
                    </p>
                </div>
                <div class="schedule-column">
                    <h3>Dub Night</h3>
                    <p class="time">THURSDAYS 8pm - 10pm</p>
                    <p>
                        A heavyweight session dedicated to DUB lovers around the world. Expect classics from the 2000s mixed
                        in with heart-stopping heavyweights from dub producers of today, including King Earthquake himself.
                        Make sure you’re plugged into a solid bass box to feel the Thursday night vibrations.
                    </p>
                </div>
            </div>
        </div>
    `,

    _bound_ketv_start: null,
    _bound_chatbox_enable: null,
    _bound_chatbox_dismiss: null,
    _ketv_status_unsubscribe: null,
    is_online: false,
    was_online: false,
    $ketv_video: null,
    $ketv_video_starter: null,

    $chatbox_wrapper: null,
    $chatbox_iframe: null,
    $chatbox_placeholder: null,
    $chatbox_enable_button: null,
    $chatbox_dismiss: null,

    update_ketv_video(online, force = false) {
        let changed = online !== this.is_online;
        if (online) {
            this.is_online = true;
            this.was_online = true;
            this.$ketv_video.classList.remove('hidden');

            if (store.get('consent').chatbox === true) {
                this.$chatbox_iframe.src = "https://www2.cbox.ws/box/?boxid=2408911&boxtag=3e7vpu";
            }
        } else if (this.was_online) {
            this.is_online = false;
            this.$ketv_video_starter.classList.add('hidden');
            document.getElementById('ketv-stream-ended').classList.remove('hidden');
            document.getElementById('video-slot').classList.add('hidden');
        } else {
            this.is_online = false;
            this.$ketv_video.classList.add('hidden');
        }

        if (changed || force) {
            this.update_media_player_location();
        }
    },

    update_media_player_location() {
        if (window.App && window.App.MediaPlayer) {
            const player = window.App.MediaPlayer;

            if (this.is_online) {
                if (player.service() === 'ketv' || player.service() === null) {
                    document.getElementById('video-slot').classList.remove('hidden');
                    player.teleport('video-slot');
                } else {
                    this.$ketv_video_starter.classList.remove('hidden');
                }

            } else {
                if (player.service() === 'ketv') {
                    window.App.MediaPlayer.resetLocation();
                }
            }
        }
    },

    start_ketv_video() {
        if (this.is_online && window.App && window.App.MediaPlayer) {
            const player = window.App.MediaPlayer;

            player.loadPlaylist([
                {
                    title: 'KETV Radio',
                    url: getConfig('ketv_url'),
                    live: true,
                    service: 'ketv',
                }
            ]);

            player.teleport('video-slot');

            document.getElementById('main-hls-video').play();

            this.$ketv_video_starter.classList.add('hidden');
            document.getElementById('video-slot').classList.remove('hidden');
        }
    },

    enable_chatbox() {
        let consent = store.get('consent');
        consent.chatbox = true;
        store.set('consent', consent);

        this.$chatbox_placeholder.classList.add('hidden');
        this.$chatbox_iframe.src = "https://www2.cbox.ws/box/?boxid=2408911&boxtag=3e7vpu";
        this.$chatbox_iframe.classList.remove('hidden');

        if (this.$chatbox_enable_button && this._bound_chatbox_enable) {
            this.$chatbox_enable_button.removeEventListener('click', this._bound_chatbox_enable);
            this._bound_chatbox_enable = null;
        }

        if (this.$chatbox_dismiss && this._bound_chatbox_dismiss) {
            this.$chatbox_dismiss.removeEventListener('click', this._bound_chatbox_dismiss);
            this._bound_chatbox_dismiss = null;
        }
    },

    disable_chatbox() {
        this.$chatbox_wrapper.classList.add('hidden');

        if (this.$chatbox_enable_button && this._bound_chatbox_enable) {
            this.$chatbox_enable_button.removeEventListener('click', this._bound_chatbox_enable);
            this._bound_chatbox_enable = null;
        }

        if (this.$chatbox_dismiss && this._bound_chatbox_dismiss) {
            this.$chatbox_dismiss.removeEventListener('click', this._bound_chatbox_dismiss);
            this._bound_chatbox_dismiss = null;
        }
    },

    onMount() {
        document.body.classList.add("frame");

        this.$ketv_video = document.getElementById('ketv-video');
        this.$ketv_video_starter = document.getElementById('ketv-video-starter');
        this.$chatbox_wrapper = document.getElementById('chatbox-wrapper');
        this.$chatbox_iframe = document.getElementById('chatbox-iframe');
        this.$chatbox_placeholder = document.getElementById('chatbox-placeholder');
        this.$chatbox_enable_button = document.getElementById('chatbox-enable');
        this.$chatbox_dismiss = document.getElementById('chatbox-dismiss');

        this.update_ketv_video(store.get('ketv').online, true);

        this._bound_ketv_start = this.start_ketv_video.bind(this);
        this.$ketv_video_starter.addEventListener('click', this._bound_ketv_start);

        const chatbox_status = store.get('consent').chatbox;
        if (chatbox_status === true) {
            this.$chatbox_placeholder.classList.add('hidden');
            this.$chatbox_iframe.classList.remove('hidden');
        } else {
            this._bound_chatbox_enable = this.enable_chatbox.bind(this);
            this.$chatbox_enable_button.addEventListener('click', this._bound_chatbox_enable);
            this._bound_chatbox_dismiss = this.disable_chatbox.bind(this);
            this.$chatbox_dismiss.addEventListener('click', this._bound_chatbox_dismiss);
        }

        this._ketv_status_unsubscribe = store.subscribe('ketv', (ketvState) => {
            this.update_ketv_video(ketvState.online)
        });
    },
    onUnmount() {
        document.body.classList.remove("frame");

        if (window.App && window.App.MediaPlayer && window.App.MediaPlayer.service() === 'ketv') {
            window.App.MediaPlayer.resetLocation();
        }

        if (this.$ketv_video_starter && this._bound_ketv_start) {
            this.$ketv_video_starter.removeEventListener('click', this._bound_ketv_start);
        }

        if (this.$chatbox_enable_button && this._bound_chatbox_enable) {
            this.$chatbox_enable_button.removeEventListener('click', this._bound_chatbox_enable);
        }

        if (this.$chatbox_dismiss && this._bound_chatbox_dismiss) {
            this.$chatbox_dismiss.removeEventListener('click', this._bound_chatbox_dismiss);
        }

        if (this._ketv_status_unsubscribe) this._ketv_status_unsubscribe();
    }
};
